import { ChevronDown, Globe } from "lucide-react";
import { createTranslator, isRTL, localeNames, locales, type Locale } from "./i18n";

/** One native, keyboard-accessible picker shared by every web surface. */
export function LanguageSwitcher({ locale, onChange }: {
  locale: Locale;
  onChange: (locale: Locale) => void;
}) {
  const label = createTranslator(locale)("language");
  return (
    <div className="global-language-bar">
      <div className="global-language-switcher">
        <label className="global-language-label" htmlFor="global-language-select">{label}</label>
        <Globe className="global-language-globe" size={20} aria-hidden="true" />
        <select
          id="global-language-select"
          aria-label={label}
          title={`${label}: ${localeNames[locale]}`}
          dir={isRTL(locale) ? "rtl" : "ltr"}
          value={locale}
          onChange={(event) => {
            const next = event.target.value as Locale;
            if (next !== locale && locales.includes(next)) onChange(next);
          }}
        >
          {locales.map((value) => (
            <option key={value} value={value} lang={value} dir={isRTL(value) ? "rtl" : "ltr"}>
              {localeNames[value]}
            </option>
          ))}
        </select>
        <ChevronDown className="global-language-chevron" size={16} aria-hidden="true" />
      </div>
    </div>
  );
}
